/**
 * vue 에서 최초로 호출하는 레이어
 * vue component (push handler) >> push methods >> push service >> vuex
 */
import vuexStore from '@/vuex-store';
import { fulfillmentPushMethod } from './fulfillmentPushMethod';
import { MapWorker } from '../map-control/model';
const { state } = vuexStore;
/**
 * 푸시 이벤트 풀필먼트
 * @param workerData 푸시 워커 데이터
 */
export const handlePushFulfillment = (_pushData) => {
    const worker = new MapWorker(_pushData);
    worker.setShareWorker(state.hubSelector.subscribeHubInfo[0].id);
    const { user } = worker;
    const { code, attendCode } = user;
    const fn = `event_worker_${attendCode.toLowerCase()}`;
    console.log('🛵[handlePushFulfillment]'
        + ` WorkerCode: ${code},`
        + ` attendCode: ${attendCode}`);
    fulfillmentPushMethod[fn]({
        pushData: worker,
        code,
        attendCode,
    });
    fulfillmentPushMethod.deleteWaitingShareWorker(worker, code);
};
